import { Text } from "@hightouch/htui";

import { Card } from "src/components/card";

type Props = {
  label: string;
  value: string;
};

export function MediaDetailMetric({ label, value }: Props) {
  return (
    <Card p={3} flex="1" minW="100px">
      <Text size="sm" color="text.tertiary">
        {label}
      </Text>
      <Text variant="monospace" size="lg" fontWeight="medium" mt={1}>
        {value}
      </Text>
    </Card>
  );
}
